export default __webpack_public_path__ + "static/media/inovas2.c4fd6f73.jpg";